export var IndexDetailsMapper = function (data) {
    var result = {
        defExc: "",
        showTrade: false,
        userIndices: {
            bull: [],
        },
    };
    var list = [];
    if (data) {
        result.defExc = data.defExc;
        result.showTrade = data.showTrade;
        if (data.userIndices &&
            data.userIndices.bull &&
            data.userIndices.bull.length > 0) {
            data.userIndices.bull.map(function (indice) {
                list.push({
                    symbol: indice.sym,
                    changePercentage: indice.chgP,
                    exchange: indice.exc,
                    status: indice.sts,
                    change: indice.chg,
                    stockName: indice.dpName,
                    aTyp: indice.aTyp,
                    lastTradedPrice: indice.ltp,
                    idx: indice.idx,
                    lastTradedTime: indice.ltt,
                });
            });
        }
        result.userIndices.bull = list;
    }
    return result;
};
